var _defineProperty = require("D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
module.exports = function (modules) {
  var installedModules = {};
  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }
  return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.r = function (exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, __webpack_require__.t = function (value, mode) {
    if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
    if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
    var ns = Object.create(null);
    if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
      enumerable: !0,
      value: value
    }), 2 & mode && "string" != typeof value) for (var key in value) __webpack_require__.d(ns, key, function (key) {
      return value[key];
    }.bind(null, key));
    return ns;
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module.default;
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = "./index.js");
}({
  "../../node_modules/webpack/buildin/global.js": function __node_modules_webpack_buildin_globalJs(module, exports) {
    var g;
    g = function () {
      return this;
    }();
    try {
      g = g || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (g = window);
    }
    module.exports = g;
  },
  "./defaults/defaultConfig.json": function _defaults_defaultConfigJson(module) {
    module.exports = JSON.parse('{"jutroAppRouterBasename":"/","launchWithTheme":"Business","submitToServer":false,"localeSettings":{"availableLocales":["en-US"],"availableLanguages":["en"],"preferredLocale":"en-US","preferredLanguage":"en","defaultCountryCode":"US"}}');
  },
  "./env-config.js": function _envConfigJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    (function (global) {
      __webpack_require__.d(__webpack_exports__, "e", function () {
        return loadAndMergeConfiguration;
      }), __webpack_require__.d(__webpack_exports__, "f", function () {
        return loadConfiguration;
      }), __webpack_require__.d(__webpack_exports__, "a", function () {
        return getConfiguration;
      }), __webpack_require__.d(__webpack_exports__, "g", function () {
        return setConfiguration;
      }), __webpack_require__.d(__webpack_exports__, "c", function () {
        return getConfigValue;
      }), __webpack_require__.d(__webpack_exports__, "b", function () {
        return getAndExtendConfigValue;
      }), __webpack_require__.d(__webpack_exports__, "d", function () {
        return isFeatureEnabled;
      });
      __webpack_require__("core-js/modules/es.string.replace");
      var _babel_runtime_corejs3_core_js_stable_url_search_params__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/url-search-params"),
        _babel_runtime_corejs3_core_js_stable_url_search_params__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_url_search_params__WEBPACK_IMPORTED_MODULE_1__),
        _babel_runtime_corejs3_core_js_stable_symbol_for__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/symbol/for"),
        _babel_runtime_corejs3_core_js_stable_symbol_for__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_symbol_for__WEBPACK_IMPORTED_MODULE_2__),
        lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("lodash"),
        lodash__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__),
        warning__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("warning"),
        warning__WEBPACK_IMPORTED_MODULE_4___default = __webpack_require__.n(warning__WEBPACK_IMPORTED_MODULE_4__),
        _load_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./load-config.js"),
        _defaults_defaultConfig_json__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./defaults/defaultConfig.json");
      function loadAndMergeConfiguration(config) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return loadConfiguration(config, params, _defaults_defaultConfig_json__WEBPACK_IMPORTED_MODULE_6__);
      }
      function loadConfiguration() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var baseConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _defaults_defaultConfig_json__WEBPACK_IMPORTED_MODULE_6__;
        return warning__WEBPACK_IMPORTED_MODULE_4___default()(lodash__WEBPACK_IMPORTED_MODULE_3___default.a.isNil(config.jutroAppRouterBasename), "jutroAppRouterBasename configuration value has been deprecated. Use JUTRO_ROUTER_BASENAME or REACT_APP_JUTRO_ROUTER_BASENAME instead (see Jutro docs for more details)."), baseConfig && (config = lodash__WEBPACK_IMPORTED_MODULE_3___default.a.mergeWith(baseConfig, config, function (target, src) {
          if (lodash__WEBPACK_IMPORTED_MODULE_3___default.a.isArray(target) && lodash__WEBPACK_IMPORTED_MODULE_3___default.a.isArray(src)) return src;
        })), setConfiguration(config = Object(_load_config__WEBPACK_IMPORTED_MODULE_5__.a)(config, params)), warning__WEBPACK_IMPORTED_MODULE_4___default()(lodash__WEBPACK_IMPORTED_MODULE_3___default.a.isNil(getConfigValue("useHashRouter")), "useHashRouter configuration value has been deprecated"), config;
      }
      var CONFIG_DATA_KEY = _babel_runtime_corejs3_core_js_stable_symbol_for__WEBPACK_IMPORTED_MODULE_2___default()("jutro.config.data");
      function getConfiguration() {
        return global[CONFIG_DATA_KEY];
      }
      function setConfiguration(config) {
        global[CONFIG_DATA_KEY] = _objectSpread({}, config);
      }
      function resolvedValue(path, value, defaultValue) {
        var parsedValue = function (value) {
          return "true" === value || "false" !== value && value;
        }(value);
        return parsedValue === defaultValue && warning__WEBPACK_IMPORTED_MODULE_4___default()(!0, "Configuration for '".concat(path, "' defined with the default value")), parsedValue;
      }
      function getConfigValue(path, defaultValue) {
        var value = null;
        if (value = new _babel_runtime_corejs3_core_js_stable_url_search_params__WEBPACK_IMPORTED_MODULE_1___default.a(window.location.search).get(path) || __FULL_ENV__[path], value) return resolvedValue(path, value, defaultValue);
        if (value = __FULL_ENV__["REACT_APP_" + path.replace(/\./g, "_")], value) return resolvedValue(path, value, defaultValue);
        var config = getConfiguration();
        return value = lodash__WEBPACK_IMPORTED_MODULE_3___default.a.get(config, path), void 0 === value ? (warning__WEBPACK_IMPORTED_MODULE_4___default()(!0, "No configuration defined for '".concat(path, "', falling back to the default value.")), defaultValue) : resolvedValue(path, value, defaultValue);
      }
      function getAndExtendConfigValue(path, extension) {
        var configValue = getConfigValue(path);
        return lodash__WEBPACK_IMPORTED_MODULE_3___default.a.merge(configValue, extension);
      }
      function isFeatureEnabled(path) {
        var allEnabled = getConfigValue("feature.all", !0);
        return getConfigValue("feature." + path, allEnabled);
      }
    }).call(this, __webpack_require__("../../node_modules/webpack/buildin/global.js"));
  },
  "./index.js": function _indexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, "loadAndMergeConfiguration", function () {
      return env_config.e;
    }), __webpack_require__.d(__webpack_exports__, "loadConfiguration", function () {
      return env_config.f;
    }), __webpack_require__.d(__webpack_exports__, "getConfiguration", function () {
      return env_config.a;
    }), __webpack_require__.d(__webpack_exports__, "setConfiguration", function () {
      return env_config.g;
    }), __webpack_require__.d(__webpack_exports__, "getConfigValue", function () {
      return env_config.c;
    }), __webpack_require__.d(__webpack_exports__, "getAndExtendConfigValue", function () {
      return env_config.b;
    }), __webpack_require__.d(__webpack_exports__, "DEFAULT_HTTP_TIMEOUT", function () {
      return DEFAULT_HTTP_TIMEOUT;
    }), __webpack_require__.d(__webpack_exports__, "isFeatureEnabled", function () {
      return env_config.d;
    });
    var env_config = __webpack_require__("./env-config.js");
    var DEFAULT_HTTP_TIMEOUT = 12e4;
  },
  "./load-config.js": function _loadConfigJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.d(__webpack_exports__, "a", function () {
      return substituteParametersValues;
    });
    __webpack_require__("core-js/modules/es.string.replace");
    var _babel_runtime_corejs3_core_js_stable_object_keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/object/keys"),
      _babel_runtime_corejs3_core_js_stable_object_keys__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_object_keys__WEBPACK_IMPORTED_MODULE_1__),
      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/for-each"),
      _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_2__),
      _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/trim"),
      _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_3__),
      lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("lodash"),
      lodash__WEBPACK_IMPORTED_MODULE_4___default = __webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__),
      mustache__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("mustache"),
      mustache__WEBPACK_IMPORTED_MODULE_5___default = __webpack_require__.n(mustache__WEBPACK_IMPORTED_MODULE_5__);
    var variableExpr = new RegExp("{{.+}}");
    function hasVariable(str) {
      return variableExpr.test(str);
    }
    function getValue(keyMaybeValue, params) {
      var allowMissing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var _splitKey = function (keyMaybeValue) {
          var _context, _context2;
          var r = /([\w-.]+\s+)\|\|\s+(.*)/.exec(keyMaybeValue);
          return {
            key: r ? _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_3___default()(_context = r[1]).call(_context) : keyMaybeValue,
            defaultValue: r ? _babel_runtime_corejs3_core_js_stable_instance_trim__WEBPACK_IMPORTED_MODULE_3___default()(_context2 = r[2]).call(_context2).replace(/(^['"]|['"]$)/g, "") : void 0
          };
        }(keyMaybeValue),
        key = _splitKey.key,
        defaultValue = _splitKey.defaultValue;
      var value = lodash__WEBPACK_IMPORTED_MODULE_4___default.a.get(params, key, defaultValue);
      return null == value && (allowMissing || console.warn("Error, missing key ", key, " from: ", params), value = "{{".concat(keyMaybeValue, "}}")), value;
    }
    function substitute(str, params) {
      var allowMissing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var tokens = mustache__WEBPACK_IMPORTED_MODULE_5___default.a.parse(str, ["{{", "}}"]);
      var buffer = "";
      return _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_2___default()(tokens).call(tokens, function (token) {
        var symbol = token[0],
          textOrKey = token[1];
        switch (symbol) {
          case "name":
            buffer += getValue(textOrKey, params, allowMissing);
            break;
          case "text":
            buffer += textOrKey;
            break;
          default:
            throw new Error("Parse error, unexpected symbol: " + symbol);
        }
      }), buffer;
    }
    function concatPath(path, addPath) {
      var str = "number" == typeof addPath ? "[".concat(addPath, "]") : addPath;
      return 0 === path.length ? str : "number" == typeof addPath ? "".concat(path).concat(str) : "".concat(path, ".").concat(str);
    }
    function traverse(val, callback) {
      var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      if (lodash__WEBPACK_IMPORTED_MODULE_4___default.a.isArray(val)) _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_2___default()(val).call(val, function (elem, i) {
        return traverse(elem, callback, concatPath(path, i));
      });else if (lodash__WEBPACK_IMPORTED_MODULE_4___default.a.isObject(val)) {
        var _context3;
        _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_2___default()(_context3 = _babel_runtime_corejs3_core_js_stable_object_keys__WEBPACK_IMPORTED_MODULE_1___default()(val)).call(_context3, function (key) {
          return traverse(val[key], callback, concatPath(path, key));
        });
      } else callback(val, path);
    }
    function substituteParametersValues(obj, params) {
      return traverse(obj, function (val, path) {
        lodash__WEBPACK_IMPORTED_MODULE_4___default.a.isString(val) && hasVariable(val) && lodash__WEBPACK_IMPORTED_MODULE_4___default.a.set(obj, path, substitute(val, params, !0));
      }), traverse(obj, function (val, path) {
        "string" == typeof val && hasVariable(val) && lodash__WEBPACK_IMPORTED_MODULE_4___default.a.set(obj, path, substitute(val, obj));
      }), obj;
    }
  },
  "@babel/runtime-corejs3/core-js-stable/instance/for-each": function babel_runtimeCorejs3_coreJsStable_instance_forEach(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/trim": function babel_runtimeCorejs3_coreJsStable_instance_trim(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/trim");
  },
  "@babel/runtime-corejs3/core-js-stable/object/keys": function babel_runtimeCorejs3_coreJsStable_object_keys(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/object/keys");
  },
  "@babel/runtime-corejs3/core-js-stable/symbol/for": function babel_runtimeCorejs3_coreJsStable_symbol_for(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/symbol/for");
  },
  "@babel/runtime-corejs3/core-js-stable/url-search-params": function babel_runtimeCorejs3_coreJsStable_urlSearchParams(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/url-search-params");
  },
  "core-js/modules/es.string.replace": function coreJs_modules_esStringReplace(module, exports) {
    module.exports = require("core-js/modules/es.string.replace");
  },
  lodash: function lodash(module, exports) {
    module.exports = require("lodash");
  },
  mustache: function mustache(module, exports) {
    module.exports = require("mustache");
  },
  warning: function warning(module, exports) {
    module.exports = require("warning");
  }
});